/**
 * Scene transition catalog for the motion timeline.
 */

import type { TransitionDef, TransitionId } from '@canvas/shared-types';

export const TRANSITIONS: TransitionDef[] = [
  {
    id: 'cut',
    label: 'Cut',
    defaultDurationMs: 0,
    supportsDirection: false,
    supportsColor: false,
    hint: 'Hard cut to the next scene.',
  },
  {
    id: 'crossfade',
    label: 'Crossfade',
    defaultDurationMs: 500,
    supportsDirection: false,
    supportsColor: false,
    hint: 'Blend the two scenes.',
  },
  {
    id: 'dip-to-color',
    label: 'Dip to color',
    defaultDurationMs: 600,
    supportsDirection: false,
    supportsColor: true,
    hint: 'Fade out to a color, then in.',
  },
  {
    id: 'slide',
    label: 'Slide',
    defaultDurationMs: 500,
    supportsDirection: true,
    supportsColor: false,
    hint: 'Next scene slides over the current one.',
  },
  {
    id: 'push',
    label: 'Push',
    defaultDurationMs: 500,
    supportsDirection: true,
    supportsColor: false,
    hint: 'Next scene pushes the current one out.',
  },
  {
    id: 'wipe',
    label: 'Wipe',
    defaultDurationMs: 500,
    supportsDirection: true,
    supportsColor: false,
    hint: 'Hard edge reveals the next scene.',
  },
  {
    id: 'zoom-blur',
    label: 'Zoom blur',
    defaultDurationMs: 400,
    supportsDirection: false,
    supportsColor: false,
    hint: 'Punchy zoom into the next scene.',
  },
];

/** Look up a transition definition; unknown ids resolve to Cut. */
export function transitionDef(id: TransitionId): TransitionDef {
  return TRANSITIONS.find((t) => t.id === id) || TRANSITIONS[0];
}

/** True when the transition produces no overlap between scenes. */
export function isHardCut(id: TransitionId): boolean {
  return id === 'cut' || id === 'none';
}
